import React from 'react'
import { bool, func, string } from 'prop-types'

import { Modal, ModalBody, SVGIcon } from 'components/qstrap'
import Relazsizes from 'relazsizes'

const VideoModal = ({
  isOpen,
  onVideoClose,
  videoSource,
}) => (
  <Modal
    autoFocus={false}
    isOpen={isOpen}
    fade={false}
    toggle={onVideoClose}
    className="video-modal__dialog"
  >
    <div className="video-modal__close">
      <button className="btn-close pull-right" type="button" onClick={onVideoClose}>
        <SVGIcon name="common-close" size="md" fill="#fff"/>
      </button>
    </div>
    <ModalBody>
      <div className="video-modal__vwrapper">
        <Relazsizes
          el="iframe"
          className="video-modal__vplayer"
          dataSrc={videoSource}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </ModalBody>
    <style jsx global>
      {`
        .video-modal {
          &__dialog {
            height: 100vh;
            display: flex;
            align-items: center;
            @media screen and (min-width: 768px) {
              max-width: 50rem;
            }
            .modal-content {
              flex-grow: 1;
              background-color: transparent !important;
              border: none !important;
              box-shadow: none !important;
              padding-top: 48px;
            }
            .modal-body {
              padding: 0;
            }
          }
          &__vwrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 */
            padding-top: 25px;
            height: 0;
          }
          &__vplayer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          &__close {
            position: absolute;
            top: 0;
            right: 0;
            button {
              background: none;
              border: none;
              svg {
                color: #fff;
              }
            }
          }
        }
      `}
    </style>
  </Modal>
)

VideoModal.propTypes = {
  isOpen: bool,
  onVideoClose: func,
  videoSource: string,
}

export default VideoModal
